<template>

<BasePanel
        headline="lang_GENERAL_PANEL_CAPTION_SPLITS"
        :alvqa="alvqa"
    >

    <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="items"
                :header-props="{ sortIcon: '' }"
                hide-default-footer
                :loading-text="$t('lang_GENERAL_LOADING_DATATABLE')"
                :items-per-page="300"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
            >

            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>


                <!-- Items -->
                <template v-slot:[`item.license`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-license'">
                        {{ getLicence(item.license) }}
                    </div>
                </template>
                <template v-slot:[`item.salesType`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-sales-type'">
                        {{ getSalesType(item.salesType) }}
                    </div>
                </template>
                <template v-slot:[`item.salesUnit`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-sales-unit'">
                        {{ getSalesUnit(item.salesUnit) }}
                    </div>
                </template>
                
                <template v-slot:[`item.base`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-' + item.id + '-text-base'"
                    >
                        {{ $alvPlugin.getNumberLocalization(item.base, 'number') }}
                    </div>
                </template>  
                <template v-slot:[`item.share`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-' + item.id + '-text-split'"
                    >
                        {{ $alvPlugin.getNumberLocalization(item.share, 'number') }}
                    </div>
                </template>
                <template v-slot:[`item.region`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-region'">
                        {{ $alvPlugin.createRegionsToString(item.region) }}
                    </div>
                </template> 
                <template v-slot:[`item.category`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-category'">
                        {{ $t(getCategory(item.category)) }}
                    </div>
                </template>

            </v-data-table>

    </template>
</BasePanel>
  
</template>

<script>

import 
    { 
        DropdownContractsLabelPriceCategories, 
        DropdownContractsLabelSalesType,
        DropdownContractsLabelLicense,
        DropdownContractsLabelSalesUnits
    } 
from '@/assets/dropdowns/alvDropdowns.js'

import BasePanel from '@/components/_base/BasePanel'


export default {

    name:'LabelContractsSplitsReadOnlyPanel',

    components: {
        BasePanel,

    },
    data() {
        return {
            alvqa: 'contracts-label-read-only-panel-splits'
        }
    },
    computed: {
        items() {
            return this.$store.getters.getLabelContractsSplits
        },
        headers() {
            return [
                {
                    text: this.$t("lang_GENERAL_CAPTION_LICENSE"),
                    value: "license",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-license'
                },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_SALES_TYPE"),
                    value: "salesType",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-sales-type'
                },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_SALES_UNIT"),
                    value: "salesUnit",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-sales-unit'
                },
                {
                    text: this.$t("lang_CONTRACTS_LABEL_EDIT_SPLITS_PANEL_CAPTION_BASE") + ' %',
                    value: "base",
                    align: "right",
                    width: "105px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-base'
                },
                {
                    text: this.$t("lang_GENERAL_CAPTION_SPLIT") + ' %',
                    value: "share",  
                    align: "right",
                    width: "105px",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-shares'
                },
                {
                    text: this.$t("lang_CONTRACTS_PUBLISHING_EDIT_SHARES_PANEL_CAPTION_REGION"),
                    value: "region",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-region'
                },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_CATEGORY"),
                    value: "category",
                    align: "left",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-category'
                },
            ]
        },
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {
        
        
        getLicence(licenseValue) {
           let licenseMatch = DropdownContractsLabelLicense.find(license => {
               return license.value === licenseValue
           })

           if(licenseMatch !== undefined)
                return this.$alvPlugin.isLangConst(licenseMatch.text) ? this.$t(licenseMatch.text) : licenseMatch.text
           else return ''
        },

        getSalesType(salesTypeValue) {
           let salesTypeMatch  = DropdownContractsLabelSalesType.find(type => {
               return type.value === salesTypeValue
           })

           if(salesTypeMatch !== undefined) {
               return this.$alvPlugin.isLangConst(salesTypeMatch.text) ? this.$t(salesTypeMatch.text) : salesTypeMatch.text
            } else return ''
        },

        getSalesUnit(salesUnitValue) {
           let salesUnitMatch = DropdownContractsLabelSalesUnits.find(unit => {
               return unit.value === salesUnitValue
           })

           if(salesUnitMatch !== undefined) return salesUnitMatch.text
           else return ''
        },

        getCategory(categoryValue) {
            let match = DropdownContractsLabelPriceCategories.find(category => {
                return category.value === categoryValue
            })

            if(match !== undefined) return match.text
            else return ''
        },

    }

}
</script>

<style>

</style>